import React, { useContext } from 'react';
import { Platform, Pressable, StyleSheet, Text, View } from 'react-native';
import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import { Avatar } from '../common/Avatar';
import { StyledWebView } from '../common/StyledWebView';
import { H3 } from '../text';
import { fetchPage } from '../../common/Api';
import AppContext from '../../contexts/App';
import LayoutContext from '../../contexts/Layout';

const ServiceBlock = ({ containerStyle, date, details, onClick, renderBorder, sermonTitle, speaker, speakerImage, width }) => {
    const { dispatch } = useContext(AppContext);
    const { layout } = useContext(LayoutContext);
    const parsedDate = typeof date === 'string' ? parseISO(date) : new Date(date);
    const formattedDate = Platform.OS.equals('web') ? format(parsedDate, 'EEEE MMMM do yyyy, h:mm a') : format(parsedDate, 'EEEE MMMM do yyyy');

    const borderStyle = {
        borderBottomColor: renderBorder ? '#dde4e9' : undefined,
        borderBottomWidth: renderBorder ? 1 : undefined
    };

    const styles = StyleSheet.flatten(Styles.container, borderStyle, containerStyle, { marginTop: 5 });

    return (
        <Pressable onPress={onClick} style={{ cursor: onClick ? 'pointer' : 'auto' }}>
            <View style={styles}>
                {speakerImage && <Avatar imageUri={speakerImage} style={{ justifyContent: 'base', marginLeft: 0 }} />}
                <View style={{ flex: 1 }}>
                    <View style={{ marginBottom: layout.styleGuide.spacer4 }} dataSet={{ spacerBottom: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})` }}>
                        <H3 text={sermonTitle} />
                    </View>
                    <View
                        style={{
                            alignItems: layout.device.isMobile ? undefined : 'center',
                            flexDirection: layout.device.isMobile ? 'column' : 'row',
                            lineHeight: layout.device.isMobile ? 1.5 : '1.5pt',
                            marginBottom: layout.styleGuide.spacer4
                        }}
                        dataSet={{ spacerBottom: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})` }}
                    >
                        {!speaker?.isEmpty() && (
                            <Text onPress={async () => await fetchPage(dispatch, `/speaker-pages/${speaker.replaceAll(' ', '-').toLowerCase()}`)} style={Styles.byLine}>
                                {speaker}
                                {!layout.device.isMobile && <Text style={{ color: '#7f868b' }}>{' | '}</Text>}
                            </Text>
                        )}

                        <Text style={Styles.dateText}>{formattedDate}</Text>
                    </View>
                    <View>
                        <StyledWebView customStyle={{ marginHorizontal: layout.styleGuide.spacer2 }} html={details} width={width} />
                    </View>
                </View>
            </View>
        </Pressable>
    );
};

const Styles = StyleSheet.create({
    byLine: {
        color: '#153d6e',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '16pt' : 15,
        cursor: 'pointer'
    },
    container: {
        flexDirection: 'row',
        marginBottom: 10
    },
    dateText: {
        color: '#7f868b',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '14pt' : 13
    }
});

ServiceBlock.propTypes = {
    date: PropTypes.string.isRequired,
    details: PropTypes.string.isRequired,
    speaker: PropTypes.string.isRequired,
    speakerImage: PropTypes.string.isRequired,
    sermonTitle: PropTypes.string.isRequired
};

export default ServiceBlock;
